import React, { useRef } from "react";
import { Users, Clock, Sparkles, ArrowRightLeft } from "lucide-react";
import { useInView } from "../hooks/useInView";

const bullets = [
  { icon: Clock, text: "Timeline coordination with planners" },
  { icon: Sparkles, text: "Clean, organized setup" },
  { icon: ArrowRightLeft, text: "Smooth transitions for speeches and formalities" },
];

export const TrustedByPlanners = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { threshold: 0.1 });

  return (
    <section
      ref={sectionRef}
      className="section-padding bg-warm-white relative"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          {/* Header */}
          <div
            className={`mb-10 ${
              isInView ? "animate-fade-in-up" : "opacity-0"
            }`}
          >
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gold/10 mb-6">
              <Users className="h-7 w-7 text-gold" />
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-charcoal mb-6">
              Trusted by Wedding{" "}
              <span className="text-gold-gradient">Planners & Venues</span>
            </h2>
          </div>

          {/* Description */}
          <p
            className={`text-charcoal/60 text-lg leading-relaxed mb-10 ${
              isInView ? "animate-fade-in-up" : "opacity-0"
            }`}
            style={{ animationDelay: "150ms", animationFillMode: "both" }}
          >
            We work closely with planners, venues, and photographers to keep the
            evening running smoothly. Clear communication, organized timelines,
            and professional coordination ensure every vendor can focus on what
            they do best, creating an unforgettable celebration.
          </p>

          <p
            className={`text-charcoal/55 text-base leading-relaxed mb-10 ${
              isInView ? "animate-fade-in-up" : "opacity-0"
            }`}
            style={{ animationDelay: "220ms", animationFillMode: "both" }}
          >
            Trusted by couples and planners at venues across Colorado, including
            The Manor House, Spruce Mountain Ranch, Della Terra, and Moss Denver.
          </p>

          {/* Bullets */}
          <div
            className={`inline-flex flex-col sm:flex-row gap-6 sm:gap-10 ${
              isInView ? "animate-fade-in-up" : "opacity-0"
            }`}
            style={{ animationDelay: "300ms", animationFillMode: "both" }}
          >
            {bullets.map((bullet, index) => {
              const Icon = bullet.icon;
              return (
                <div
                  key={index}
                  className="flex items-center gap-3 text-charcoal/70"
                >
                  <div className="w-8 h-8 rounded-lg bg-gold/10 flex items-center justify-center flex-shrink-0">
                    <Icon className="h-4 w-4 text-gold" />
                  </div>
                  <span className="text-sm font-medium">{bullet.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
